// extracted by mini-css-extract-plugin
export default {"default-avatar":"Avatar_default-avatar__V0u1l","user-avatar":"Avatar_user-avatar__eTVbJ","avatar-select":"Avatar_avatar-select__gfNE9","logout":"Avatar_logout__mlz5p"};